import { DateAfter, DateBefore, DateRange } from 'react-day-picker';

export const ESCAPE = 'Escape';
export const TAB = 'Tab';

export const DATE_FORMAT = 'dd/MM/yyyy';
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export type Props = {
  fromField: string;
  toField: string;
  fromFieldValue?: Date;
  toFieldValue?: Date;
  disabledDays?: (DateBefore | DateAfter)[];
  selectedDays: DateRange;
  fromMonth?: Date;
  toMonth?: Date;
  onRangeChange: (range: DateRange) => void;
};
